import { useState, useEffect } from 'react';
import { useFirestore } from '../../hooks/useFirestore';
import { Pizza } from '../../types';
import PizzaForm from '../../components/admin/PizzaForm';
import AdminLayout from '../../components/admin/AdminLayout';

export default function AdminPizzas() {
  const { searchPizzas, loading, error } = useFirestore();
  const [pizzas, setPizzas] = useState<Pizza[]>([]);
  const [selectedPizza, setSelectedPizza] = useState<Pizza | null>(null);
  const [isFormOpen, setIsFormOpen] = useState(false);

  useEffect(() => {
    loadPizzas();
  }, []);

  const loadPizzas = async () => {
    const results = await searchPizzas({ type: 'pizza', query: '' });
    setPizzas(results);
  };

  const handleEdit = (pizza: Pizza) => {
    setSelectedPizza(pizza);
    setIsFormOpen(true);
  };

  const handleCreate = () => {
    setSelectedPizza(null);
    setIsFormOpen(true);
  };

  const handleFormClose = () => {
    setIsFormOpen(false);
    setSelectedPizza(null);
    loadPizzas(); // Refresh the list
  };

  return (
    <AdminLayout title="Gestione Pizze" error={error}>
      <div className="mb-4">
        <button
          onClick={handleCreate}
          className="bg-pizzaveg hover:bg-pizzaveg-dark text-white px-4 py-2 rounded-lg"
        >
          Aggiungi Pizza
        </button>
      </div>

      {loading ? (
        <div>Caricamento...</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {pizzas.map(pizza => (
            <div key={pizza.id} className="bg-white rounded-lg shadow-md overflow-hidden">
              <img
                src={pizza.imageUrl}
                alt={pizza.name}
                className="w-full h-48 object-cover"
              />
              <div className="p-4">
                <h3 className="font-bold text-lg mb-2">{pizza.name}</h3>
                <p className="text-gray-600 text-sm mb-2">{pizza.description}</p>
                <p className="text-sm text-gray-500">
                  Ingredienti: {pizza.ingredients.join(', ')}
                </p>
                <div className="mt-4">
                  <button
                    onClick={() => handleEdit(pizza)}
                    className="bg-pizzaveg hover:bg-pizzaveg-dark text-white px-3 py-1 rounded-lg text-sm"
                  >
                    Modifica
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {isFormOpen && (
        <PizzaForm
          pizza={selectedPizza}
          onClose={handleFormClose}
        />
      )}
    </AdminLayout>
  );
}